
(() => {
  'use strict';
  const keys = { wishlist: 'm-wishlist-products', compare: 'm-compare-products', recent: 'phd-recently-viewed-handles' };
  const read = mode => { try { const v = JSON.parse(localStorage.getItem(keys[mode]) || '[]'); return Array.isArray(v) ? [...new Set(v.filter(x => typeof x === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(x)))] : []; } catch { return []; } };
  const memory = Object.fromEntries(Object.keys(keys).map(k => [k, read(k)]));
  const save = (mode, values) => { memory[mode] = values; try { localStorage.setItem(keys[mode], JSON.stringify(values)); } catch {} };
  const labels = { wishlist: ['Save to wishlist', 'Saved to wishlist'], compare: ['Add to compare', 'Added to compare'] };
  const updateButtons = () => document.querySelectorAll('[data-phd-save]').forEach(b => {
    const mode = b.dataset.phdSave;
    if (!labels[mode]) return;
    const active = memory[mode].includes(b.dataset.handle);
    b.setAttribute('aria-pressed', String(active)); b.textContent = labels[mode][Number(active)];
  });
  class SavedProducts extends HTMLElement {
    connectedCallback() { this.renderProducts(); }
    async renderProducts() {
      const revision = this.revision = (this.revision || 0) + 1;
      const mode = this.dataset.mode;
      const candidates = (memory[mode] || []).filter(h => h !== this.dataset.current || mode !== 'recent');
      const handles = mode === 'recent' ? candidates.slice(0, Number(this.dataset.limit) || 8) : candidates;
      const status = this.querySelector('.phd-saved-status');
      const grid = this.querySelector('.phd-saved-grid');
      if (!status || !grid) return;
      if (!handles.length) {
        grid.replaceChildren(); this.hidden = mode === 'recent';
        status.textContent = mode === 'compare' ? 'Add products to compare from any product page.' : 'Your wishlist is empty. Save a product to find it here later.';
        return;
      }
      const root = (this.dataset.root || '/').replace(/\/$/, '');
      const results = await Promise.allSettled(handles.map(async handle => {
        const response = await fetch(`${root}/products/${encodeURIComponent(handle)}?view=phd-card`, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Product unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        return doc.querySelector('.phd-saved-card');
      }));
      if (this.revision !== revision || !this.isConnected) return;
      grid.replaceChildren();
      results.forEach(r => { if (r.status === 'fulfilled' && r.value) grid.append(document.importNode(r.value, true)); });
      this.hidden = mode === 'recent' && !grid.children.length;
      status.textContent = grid.children.length ? '' : 'These products could not be loaded. Please try again.';
    }
  }
  if (!customElements.get('phd-saved-products')) customElements.define('phd-saved-products', SavedProducts);
  document.addEventListener('click', e => {
    const saveButton = e.target.closest('[data-phd-save]');
    if (saveButton) {
      const mode = saveButton.dataset.phdSave, handle = saveButton.dataset.handle;
      if (!labels[mode] || !/^[a-z0-9][a-z0-9-]*$/.test(handle)) return;
      const exists = memory[mode].includes(handle);
      save(mode, exists ? memory[mode].filter(h => h !== handle) : [...memory[mode], handle]);
      updateButtons();
      const status = document.getElementById('phd-save-status');
      if (status) status.textContent = exists ? 'Product removed.' : labels[mode][1];
      document.querySelectorAll(`phd-saved-products[data-mode="${mode}"]`).forEach(el => el.renderProducts());
    }
    const remove = e.target.closest('.phd-remove-product');
    if (remove) {
      const parent = remove.closest('phd-saved-products'); if (!parent) return;
      save(parent.dataset.mode, memory[parent.dataset.mode].filter(h => h !== remove.dataset.handle));
      parent.renderProducts(); updateButtons();
    }
  });
  const init = () => {
    const current = document.getElementById('phd-current-product')?.dataset.handle;
    if (current) save('recent', [current, ...memory.recent.filter(h => h !== current)].slice(0, 20));
    updateButtons();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', updateButtons);
  window.addEventListener('storage', e => {
    if (Object.values(keys).includes(e.key)) {
      Object.keys(keys).forEach(k => { memory[k] = read(k); }); updateButtons();
      document.querySelectorAll('phd-saved-products').forEach(el => el.renderProducts());
    }
  });
})();
